export const transformUTCDate = (value: string | null) => {
  if (!value) {
    return null;
  }

  return {
    data: new Date(Number(value) * 1000),
  };
};
